import React, { useEffect, useState } from "react";

import { Container, Modal, Form, Button, Col, Spinner, Image } from "react-bootstrap";

import Dropdown from "react-bootstrap/Dropdown";

import ButtonGroup from "react-bootstrap/ButtonGroup";

import { Icon } from "components";

import { ERROR_MESSAGE, logout, PAGE_KEY, USER_KEY } from "store/auth";

import useRouter from "util/useRouter";

import api from "services/api";

import { ExpiredModal } from "components";



// import profileImage from "../../assets/documents.png";

import profileImage from "../../assets/user5.png";

import lockImage from "../../assets/lock.png";

import exitImage from "../../assets/exit.png";



import imgBrazil from "../../assets/brazil.png";

import imgUSA from "../../assets/usa.png";

import imgSpain from "../../assets/spain.png";



import imgPasswordOK from "assets/ok.png";
import imgPasswordError from "assets/erro.png";

import "./styles.css";

import ModalSpinner from "components/ModalSpinner";

import { LogoutModal } from "./Components";

import languages from "languages";



const stContainer = {

  height: 56,

  backgroundColor: "#006491",

  display: "flex",

  justifyContent: "space-between",

  alignItems: "center"

};



const stIcons = {

  color: "#FFFFFF",

  marginLeft: 10,

  marginRight: 10,

  fontSize: 24,

  cursor: "pointer",

  justifyContent: "center",

  alignItems: "center"

};



const stDropdownToggle = {

  backgroundColor: "transparent",

  border: 0,

  height: 24,

  width: 24,

  display: "flex",

  justifyContent: "center",

  alignItems: "center",

  marginLeft: 16,

  marginRight: 20,

  boxShadow: "none"

};



const stDropdownToggleLanguage = {

  backgroundColor: "transparent",

  border: 0,

  height: 24,

  width: 24,

  display: "flex",

  justifyContent: "center",

  alignItems: "center",

  marginLeft: 16,

  marginRight: 20,

  boxShadow: "none"

};



const stDropdownIcons = {

  color: "#000000",

  width: 16,

  height: 16,

  marginRight: 10

};



const stDropdownItem = {

  display: "flex",

  height: 32,

  textAlign: "left",

  alignItems: "center",

  fontFamily: "Roboto",

  fontStyle: "normal",

  fontWeight: "normal",

  fontSize: "12px",

  lineHeight: "13px"

};



const stButtonSave = {

  display: "flex",

  alignItems: "center",

  justifyItems: "flex-start",

  background: "#006491",

  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.175)",

  marginRight: 8,

  borderRadius: 4,

  width: 92,

  height: 32

};



const stButtonCancel = {

  display: "flex",

  alignItems: "center",

  justifyContent: "center",

  background: "#495057",

  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.175)",

  borderRadius: 4,

  width: 79,

  height: 32

};

const stSaveIcon = {

  color: "#fff",

  borderColor: "#000",

  fontSize: 24

};



const initialValidation = () => ({
  length: false, upper: false, lower: false,
  number: false, special: false, senhasIguais: false
});

const obterMensagemSenha = codigo => {
  const mensagens = {
    senhainvalida: "Informe uma senha válida.",
    senhadiferente: "As senhas informadas são diferentes.",
    senhatamanho: "A senha deve possuir de 12 a 64 caracteres.",
    senhafraca: "Esta senha apresenta padrões comuns e pode ser facilmente descoberta em tentativas de acesso indevido. Escolha uma senha mais forte, evitando palavras conhecidas, sequências e repetições.",
    senharepetida: "Esta senha já foi utilizada anteriormente. Escolha uma senha diferente.",
    senhahistorico: "Esta senha já foi utilizada anteriormente. Escolha uma senha diferente.",
    senhadadospessoais: "Esta senha contém informações pessoais ou termos comuns que podem facilitar sua descoberta, como nomes, e-mails, palavras conhecidas ou combinações frequentemente utilizadas. Escolha uma senha mais segura.",
    senhavazada: "Esta senha foi identificada em bases de senhas comprometidas. Por segurança, escolha uma senha diferente.",
    senhaverificacaoindisponivel:  "Não foi possível concluir a verificação de segurança da senha. Aguarde alguns instantes e tente novamente."
  };
  return mensagens[codigo] || null;
};

const TopBar = props => {

  const { toggleMenu, title } = props;

  const { history } = useRouter();

  const [showChangePassword, setChangePassword] = useState(false);

  const [showChangeProfile, setChangeProfile] = useState(false);

  const [password, setPassword] = useState({ pass: "", confirmPass: "" });
  const [validateInput, setValidateInput] = useState(initialValidation);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const senhaValida = validateInput.length && validateInput.senhasIguais;

  const atualizarSenha = (campo, valor) => {
    const novo = { ...password, [campo]: valor };
    setPassword(novo);
    setPasswordError("");
    setValidateInput({
      length: novo.pass.length >= 12 && novo.pass.length <= 64,
      upper: /[A-Z]/.test(novo.pass),
      lower: /[a-z]/.test(novo.pass),
      number: /[0-9]/.test(novo.pass),
      special: /[^A-Za-z0-9]/.test(novo.pass),
      senhasIguais: novo.confirmPass.length > 0 && novo.pass === novo.confirmPass
    });
  };

  const fecharAlteracaoSenha = () => {
    if (isChangingPassword) return;
    setChangePassword(false);
    setPassword({ pass: "", confirmPass: "" });
    setValidateInput(initialValidation());
    setPasswordError("");
  };

  const [openDropResponsive, setOpen] = useState(false);

  const [titlePage, setTitlePage] = useState("");

  const [success, setSuccess] = useState(false);

  const [failure, setFailure] = useState(false);

  const [isLogout, setIsLogout] = useState(false);

  const [menuEnabled, setMenuEnabled] = useState(false);

  const [expired, setExpired] = useState(false);



  const handleChange = () => {

    return setChangePassword(!showChangePassword);

  };



  const changeTitle = title => {

    localStorage.setItem(PAGE_KEY, title);

  };



  const handleMenu = () => setMenuEnabled(!menuEnabled);

  const handleSuccess = () => setSuccess(!success);

  const handleFailure = () => setFailure(!failure);

  const handleLogout = () => setIsLogout(!isLogout);



  const changeLanguage = lang => {

    alert(lang);

  };



  const changeLanguage2 = async () => {

    try {

      const user_password = { 

        password: password.pass,

        confirm_password: password.confirmPass

      };



      const response = await api().post(

        `Usuario/AlterarSenha?bolAutenticado=true`, user_password,

        {}

      );



      // const response = await api().post(

      //   `Usuario/AlterarSenha?strSenha=${password.pass}&strConfirmaSenha=${password.confirmPass}&bolAutenticado=true`,

      //   {}

      // );



      handleSuccess();

    } catch (error) {

      if (error.response.status === 401) {

        localStorage.setItem(ERROR_MESSAGE, error.response.statusText);

        setExpired(true);

      } else {

        handleFailure();

      }

    }

  };



  const changePassword = async () => {
    if (isChangingPassword || !senhaValida) return;
    setIsChangingPassword(true);
    setPasswordError("");
    try {
      const user_password = {
        password: password.pass,
        confirm_password: password.confirmPass
      };
      await api().post("Usuario/AlterarSenha?bolAutenticado=true", user_password, {});
      setChangePassword(false);
      setPassword({ pass: "", confirmPass: "" });
      setValidateInput(initialValidation());
      setSuccess(true);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.setItem(ERROR_MESSAGE, error.response.statusText || "Sessão expirada");
        setExpired(true);
      } else {
        const resposta = error.response?.data;
        const codigo = typeof resposta === "string" ? resposta.trim() : null;
        const mensagem = obterMensagemSenha(codigo);
        setPasswordError(mensagem || resposta?.Message || "Não foi possível alterar a senha.");
      }
    } finally {
      setIsChangingPassword(false);
    }
  };

  useEffect(() => {

    setTitlePage(title);

  }, [title]);



  return (

    <Container fluid className="TopBar">

      <div className={`toggleMenu ${menuEnabled ? "enable" : ""}`}>

        <Icon

          name={menuEnabled ? "close" : "menu"}

          onClick={() => {

            handleMenu();

            toggleMenu();

          }}

        />

      </div>



      <div

        className="TopBar_PageTitle"

        dangerouslySetInnerHTML={{ __html: titlePage }}

      ></div>



      <div style={{ display: "flex", alignItems: "center" }}>

        {/* <Icon

          name="exit_to_app"

          title="Sair"

          style={stIcons}

          onClick={() => {

            handleLogout();

          }}

        /> */}





        {/* 

        Botão do Idioma

        <Dropdown as={ButtonGroup} className="Topbar__Dropdown_Language">

          <Dropdown.Toggle style={stDropdownToggle}>

            <Icon name="public" 

                  title="Idioma"/> 

          </Dropdown.Toggle>



          <Dropdown.Menu

            className="Topbar_Dropdown__Menu"

            rootCloseEvent="click"

            >    

            <Dropdown.Item

              eventKey="0"

              style={stDropdownItem}

              onClick={() => changeLanguage('pt')}

            >

              <div style={stDropdownIcons}>

                <img src={imgBrazil} />

              </div>

              Português

            </Dropdown.Item> 



            <Dropdown.Item

              eventKey="1"

              style={stDropdownItem}

              onClick={() => changeLanguage('en')}

            >

              <div style={stDropdownIcons}>

                <img src={imgUSA} />

              </div>

              English

            </Dropdown.Item>



            <Dropdown.Item

              eventKey="2"

              style={stDropdownItem}

              onClick={() => changeLanguage('es')}

            >

              <div style={stDropdownIcons}>

                <img src={imgSpain} />

              </div>

              Español

            </Dropdown.Item>

          </Dropdown.Menu>

        </Dropdown> */}

























        {/* perfil aqui  */}

        <Dropdown as={ButtonGroup} className="Topbar__Dropdown">



            <Dropdown.Toggle style={stDropdownToggle}>

              <Icon name="account_circle" 

                    title="Perfil"/> 

            </Dropdown.Toggle>



          <Dropdown.Menu

            className="Topbar_Dropdown__Menu"

            rootCloseEvent="click"

          >    

            <Dropdown.Item

              eventKey="1"

              style={stDropdownItem}

              href="#/meuperfil"

              onClick={() => changeTitle('Meu Perfil')}

            >

              <div style={stDropdownIcons}>

                <img src={profileImage} />

              </div>

              Meu Perfil

            </Dropdown.Item> 

            <Dropdown.Item

              eventKey="1"

              style={stDropdownItem}

              onClick={() => handleChange()}

            >

              <div style={stDropdownIcons}>

                <img src={lockImage} />

              </div>

              Alterar Senha

            </Dropdown.Item>

            <Dropdown.Item

              eventKey="2"

              style={stDropdownItem}

              onClick={() => {

                handleLogout();

              }}

            >

              <div style={stDropdownIcons}>

                <img src={exitImage} />

              </div>

              Sair

            </Dropdown.Item>

          </Dropdown.Menu>

        </Dropdown>



        <Icon

          id="TopBar_ResponsiveDrop"

          name="account_circle"

          style={stIcons}

          onClick={() => setOpen(!openDropResponsive)}

        />



        <div

          className={`TopBar_DropdownMobile ${

            openDropResponsive === true ? "open" : ""

          }`}

        >

          <div className="TopBar_DropdownMobile__Back">

            <Icon

              name="keyboard_arrow_down"

              onClick={() => setOpen(!openDropResponsive)}

            />

          </div>

          <div className="TopBar_DropdownMobile__Options">

          <div

              className="TopBar_DropdownMobile__OptionDiv"

              onClick={() => {

                changeTitle('Meu Perfil')

                history.push("/meuperfil")

                setOpen(!openDropResponsive)

              }}

            >

              Meu Perfil

              <Icon name="chevron_right" />

            </div>

            <div

              className="TopBar_DropdownMobile__OptionDiv"

              onClick={() => handleChange()}

            >

              Alterar Senha

              <Icon name="chevron_right" />

            </div>

            <div

              className="TopBar_DropdownMobile__OptionDiv"

              onClick={() => {

                logout();

                history.push("/logout");

              }}

            >

              Sair

              <Icon name="chevron_right" />

            </div>

          </div>

        </div>



        <Modal show={success}>

          <Modal.Body>Senha alterada com sucesso!</Modal.Body>

          <Modal.Footer>

            <Button

              onClick={() => {

                logout();

                history.push("/logout");

              }}

            >

              Iniciar Nova Sessão

            </Button>

          </Modal.Footer>

        </Modal>



        <Modal show={failure} onHide={handleFailure}>

          <Modal.Body>Falha ao alterar a senha, verifique os requisitos de complexidade.</Modal.Body>

        </Modal>



        <Modal
          show={showChangePassword}
          onHide={fecharAlteracaoSenha}
          centered
          className="Topbar_ModalPassword"
          backdrop={isChangingPassword ? "static" : true}
        >
          <Modal.Header closeButton={!isChangingPassword} className="Topbar_ModalPassword__Header">
            <Icon name="arrow_back_ios" style={{ color: "rgba(0,0,0,0.5)" }} />
            <p>Alterar Senha</p>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={e => { e.preventDefault(); changePassword(); }}>
              <Form.Row className="Topbar_Form__password" style={{ justifyContent: "flex-start" }}>
                <Form.Group style={{ marginRight: 8 }}>
                  <Form.Label>Nova Senha</Form.Label>
                  <Form.Control
                    className="Topbar_Form__PassInput"
                    type="password"
                    value={password.pass}
                    onChange={e => atualizarSenha("pass", e.target.value)}
                    minLength={12}
                    maxLength={64}
                    autoComplete="new-password"
                    disabled={isChangingPassword}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Confirmar Senha</Form.Label>
                  <Form.Control
                    className="Topbar_Form__PassInput"
                    type="password"
                    value={password.confirmPass}
                    onChange={e => atualizarSenha("confirmPass", e.target.value)}
                    minLength={12}
                    maxLength={64}
                    autoComplete="new-password"
                    disabled={isChangingPassword}
                    required
                  />
                </Form.Group>
              </Form.Row>
              <p style={{ fontSize: 14, marginTop: 12 }}>Informe sua nova senha.</p>
              <ul className="password-rules">
                {[
                  ["length", "Possuir de 12 a 64 caracteres"],
                  ["upper", "Utilizar ao menos uma letra maiúscula"],
                  ["lower", "Utilizar ao menos uma letra minúscula"],
                  ["number", "Utilizar ao menos um número"],
                  ["special", "Utilizar ao menos um caractere especial"],
                  ["senhasIguais", "As senhas devem ser iguais"]
                ].map(([chave, descricao]) => (
                  <li key={chave}>
                    <Image
                      className="password-rule-icon"
                      src={validateInput[chave] ? imgPasswordOK : imgPasswordError}
                      alt=""
                    />
                    <span>{descricao}</span>
                  </li>
                ))}
              </ul>
              <div style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: 4, padding: 12, marginBottom: 16 }}>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <Icon name="info_outline" style={{ fontSize: 20, color: "#6c757d", marginRight: 8 }} />
                  <div style={{ fontSize: 13, color: "#6c757d" }}>
                    <strong>Recomendações de segurança</strong>
                    <p style={{ marginTop: 6, marginBottom: 0 }}>
                      Evite senhas já utilizadas, palavras comuns, sequências numéricas,
                      caracteres repetidos e informações pessoais, como nome ou e-mail.
                    </p>
                  </div>
                </div>
              </div>
              {passwordError && <div className="alert alert-danger" role="alert">{passwordError}</div>}
              <Form.Row className="Topbar_Form__Buttons">
                <Button
                  className="Topbar_Form__Save"
                  style={stButtonSave}
                  type="submit"
                  disabled={!senhaValida || isChangingPassword}
                >
                  {isChangingPassword ? <Spinner animation="border" size="sm" /> : <Icon name="save" style={stSaveIcon} />}
                  {isChangingPassword ? "Salvando..." : "Salvar"}
                </Button>
                <Button
                  className="Topbar_Form__Cancel"
                  style={stButtonCancel}
                  type="button"
                  onClick={fecharAlteracaoSenha}
                  disabled={isChangingPassword}
                >
                  Cancelar
                </Button>
              </Form.Row>
            </Form>
          </Modal.Body>
        </Modal>

      </div>

      {expired && <ExpiredModal show={expired} />}



      {isLogout && <LogoutModal show={isLogout} hide={handleLogout} />}

    </Container>

  );

};



export default TopBar;
